// extracted by mini-css-extract-plugin
module.exports = {"section":"table_section__XLtfu","overlay":"table_overlay__W3sZV","tableTitle":"table_tableTitle__AP4Tb","container":"table_container__Y0yYJ"};